module.exports = __webpack_public_path__ + "static/media/12.fda23088.mp3";